import { createRoot } from 'react-dom/client';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { I18nApp } from './components/i18n';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<I18nApp ReactComponent={<App />} />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
